// extracted by mini-css-extract-plugin
export default {"fourth":"Eighth_fourth__a6gB2"};